//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setCookie } from '../../../../tools/cookie';

export default {
  name: "mobileMenu",
  props: {
    datas: {
      required: true,
    },
    theme: {
      type: String,
      value: '',
    }
  },
  inject: ["jumpCallBack", "sensors", "action"],
  data() {
    return {};
  },
  methods: {
    getClass(path = ''){
      let menuColor = '';
      if (!path) {
        if(this.theme === 'dark') {
          menuColor = 'disable-link-dark';
        } else {
          menuColor = 'disable-link-light';
        }
      }
      return menuColor;
    },
    handle(item) {
      if (this.sensors) {
        const trackDatas = {
          action_parameter1: "header",
          action_type: "click",
          ...item.eventId,
        };
        Object.assign(trackDatas, this.action);
        this.sensors.track("event_click", trackDatas);
      }
      const datas = JSON.parse(JSON.stringify(item));
      datas.path = datas.path.replace(/\$\w*\$/, location.origin);
      const { path } = datas;
      this.$emit("closeMenu");
      // item 点击跳转
      if (datas.code === 'KaCase' && !datas.path.includes('http')) { // 确认是内部页面
        if (window.location.pathname === '/'){ // 官网一级页面
          window.location.hash = 'target-section-ka';
        } else { // 官网二级页面 + 社区
          setCookie('from', 'master')
          window.location.href = window.location.origin + datas.path;
        }
      } else if (this.jumpCallBack) {
        this.jumpCallBack(datas, this.toPath);
      } else {
        this.toPath(path);
      }
    },
    toPath(path) {
      if (path && path.indexOf("http") === 0) {
        window.open(path, "_blank");
      } else if (path) {
        this.$router?.push(path);
      } else {
        const { path } = this.datas;
        this.$router?.push(path);
      }
    },
  },
};
